import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface MegaMenuShellProps {
  isOpen: boolean;
  onClose?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: React.ReactNode;
  className?: string;
}

export const MegaMenuShell: React.FC<MegaMenuShellProps> = ({ isOpen, children, className, onMouseEnter, onMouseLeave }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: 'auto' }}
        exit={{ height: 0 }}
        transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
        className={`absolute left-0 right-0 top-full z-50 w-[100vw] max-w-none bg-gray-100 shadow-2xl ${className || ''}`}
        style={{ overflow: 'hidden' }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="pointer-events-none absolute left-0 top-0 z-20 h-2 w-full bg-gradient-to-b from-black/30 via-gray-100 to-gray-100" />
        <div className="container mx-auto py-10">{children}</div>
      </motion.div>
    )}
  </AnimatePresence>
);
